import { useSearch } from '@tanstack/react-router';

/**
 * `?demo=1` (any truthy value) collapses the sidebar to 4 primary modules.
 * Reactive to client-side navigation — the router validates `demo` on the
 * `authedRoute` search schema so this hook updates whenever the param
 * changes without a page reload.
 */
export function useDemoMode(): boolean {
  return useSearch({
    from: '/authed',
    select: (s) => Boolean(s.demo),
  });
}
